import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  currentLanguage = 'EN';
  constructor(private translate: TranslateService) { }
  ngOnInit() {
    const brouserLang = this.translate.getBrowserLang();
    if (['de', 'en'].includes(brouserLang)) {
      this.translate.use(brouserLang);
      this.currentLanguage = brouserLang.toUpperCase();
    } else {
      this.translate.use(this.currentLanguage.toLowerCase());
      this.currentLanguage = this.currentLanguage.toUpperCase();
    }
  }
  languageSelected(newLang) {
    this.translate.use(newLang.toLowerCase());
    this.currentLanguage = newLang;
  }
}
